import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.5 0C12.9183 0 16.5 3.58172 16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0ZM8.5 1C4.63401 1 1.5 4.13401 1.5 8C1.5 11.866 4.63401 15 8.5 15C12.366 15 15.5 11.866 15.5 8C15.5 4.13401 12.366 1 8.5 1ZM8 3C8.24546 3 8.44961 3.17688 8.49194 3.41012L8.5 3.5V8H11C11.2761 8 11.5 8.22386 11.5 8.5C11.5 8.74546 11.3231 8.94961 11.0899 8.99194L11 9H8C7.75454 9 7.55039 8.82312 7.50806 8.58988L7.5 8.5V3.5C7.5 3.22386 7.72386 3 8 3Z",
		className: "icons-color"
	})]
});
const ForwardRef = forwardRef(SvgClockIcon);
export default ForwardRef;
